import { React, useState, useEffect } from 'react';
import Header from './Header';
import './Profile.css';
import def from '../pic/default_pfp.png';
import axios from 'axios';
import Cookies from 'js-cookie';

const Profile = () => {
  const [currUser, setCurrUser] = useState("");
  const [currPfp, setCurrPfp] = useState(def); // Default to the default profile picture
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = Cookies.get('token');
        const userId = Cookies.get('userid');
        const response = await axios.get(`https://motif-backend-production.up.railway.app/api/user/${userId}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
        });
        const data = response.data;
        setCurrUser(data.profile.username);
        
        if (data.profile.pic) {
          console.log("picture url:", data.profile.pic)
          setCurrPfp(data.profile.pic);
        }
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };
  
    fetchProfile();
  }, []);

  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
    // Create a URL for the selected file and set it to currPfp for preview
    if (file) {
        const imageUrl = URL.createObjectURL(file);
        setCurrPfp(imageUrl); // Update the current profile picture preview
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = Cookies.get('token');
    const userId = Cookies.get('userid'); // Fetch userId from cookies
    const form = new FormData();

    // Only append fields if they are provided
    if (formData.username !== '') { form.append('username', formData.username); }
    form.append('password', formData.password);
    if (selectedFile) {
      form.append('profile_picture', selectedFile);
    }

    try {
      const response = await axios.put(`https://motif-backend-production.up.railway.app/api/user/${userId}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      
      const newToken = response.data.token; // Store the new token if it's returned
      Cookies.set('token', newToken, { expires: 1 });
      
      alert('Profile updated successfully');
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Error updating profile');
    }    
  };

  return (
    <div>
      <Header />
      <div className='Profile'>
        <div className="upload-pic">
          <img src={currPfp} alt="Profile" />
        </div>
        <form className='prof-box' onSubmit={handleSubmit}>
          <div className="input-box">
            <input
              type="text"
              placeholder={currUser}
              id="username"
              value={formData.username}
              onChange={handleChange}
            />
          </div>
          <div className="input-box">
            <input
              type="password"
              placeholder="Password"
              id="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-box">
            <input
              type="file"
              id="profile_picture"
              onChange={handleFileChange}
              style={{ display: 'none' }}
            />
            <button className='profile-button' type="button" onClick={() => document.getElementById('profile_picture').click()}>Upload Profile Picture</button>
          </div>
          <button className='profile-button' type="submit">Save Change</button>
        </form>
      </div>
    </div>
  );
}

export default Profile;
